// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__15zZ3","ThumbZoom":"ChapterPlayer_ThumbZoom__wIsfx"};